import { arrow } from "@/designSystemIcons";
import { cn } from "@/lib/utils";
import { useState } from "react";

interface AccordionProps {
  children: React.ReactNode;
  label: string;
  defaultOpen?: boolean;
}

const Accordion = ({
  children,
  label,
  defaultOpen = false,
}: AccordionProps) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  return (
    <article className="flex flex-col w-full gap-y-2">
      <button
        className="flex shrink-0 items-center justify-between w-full h-10 px-2 mobile:pr-2 pr-4 mobile:text-xs text-dark-secondary bg-panel-foreground"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <span>{label}</span>
        <span className={cn("w-2 h-2", isOpen && "rotate-180")}>{arrow}</span>
      </button>
      {isOpen && children}
    </article>
  );
};

export default Accordion;
